import React from 'react';
import dayjs from 'dayjs';
import { ChevronRight, BedDouble, Plus } from 'lucide-react';
import { utcToLADateKey } from '../../utils/laDateUtils';
import { coverageBadge } from './ParticipantBookingTab';
import RoomSegmentCard from './RoomSegmentCard';

// Weekday / day / month / year as separate tokens so check-in and check-out
// can be laid out as an aligned table (each token stacks under its match).
const dateParts = (val) => {
  const key = utcToLADateKey(val);
  if (!key) return { weekday: '—', day: '', month: '', year: '' };
  const d = dayjs(key);
  return { weekday: d.format('ddd'), day: d.format('D'), month: d.format('MMM'), year: d.format('YYYY') };
};

const nightsBetween = (from, to) => {
  const a = new Date(from);
  const b = new Date(to);
  if (isNaN(a) || isNaN(b)) return 0;
  return Math.max(0, Math.round((b - a) / 86400000));
};

const StayTimelineRow = ({
  period,
  index,
  assignedGroups,
  isOpen,
  onToggle,
  onBookRoom,
  competitionId,
  participantId,
  participantName,
  guests,
  onChanged,
}) => {
  const nights = nightsBetween(period.check_in_date, period.check_out_date);
  const badge = coverageBadge(assignedGroups.length);
  const checkIn = dateParts(period.check_in_date);
  const checkOut = dateParts(period.check_out_date);

  return (
    <div className="pbt-timeline-row">
      <div className="pbt-timeline-row__date">
        <div className="pbt-timeline-row__date-table">
          <span className="pbt-timeline-row__wd">{checkIn.weekday},</span>
          <span className="pbt-timeline-row__num">{checkIn.day}</span>
          <span className="pbt-timeline-row__mo">{checkIn.month}</span>
          <span className="pbt-timeline-row__num">{checkIn.year}</span>

          <div className="pbt-timeline-row__nights-row">
            <span className="pbt-timeline-row__rule" />
            <span className="pbt-timeline-row__nights">{nights} night{nights !== 1 ? 's' : ''}</span>
            <span className="pbt-timeline-row__rule" />
          </div>

          <span className="pbt-timeline-row__wd">{checkOut.weekday},</span>
          <span className="pbt-timeline-row__num">{checkOut.day}</span>
          <span className="pbt-timeline-row__mo">{checkOut.month}</span>
          <span className="pbt-timeline-row__num">{checkOut.year}</span>
        </div>
      </div>

      <div className="pbt-timeline-row__connector">
        <span className={`pbt-status-dot ${badge.dotClassName}`} />
      </div>

      <div className="pbt-timeline-row__card">
        <button
          type="button"
          className="pbt-timeline-row__header"
          aria-label={`Toggle Stay ${index + 1}`}
          onClick={onToggle}
        >
          <span className={badge.className}>{badge.label}</span>
          <span className="pbt-timeline-row__spacer" />
          <ChevronRight
            size={18}
            className={`pbt-timeline-row__chevron${isOpen ? ' pbt-timeline-row__chevron--open' : ''}`}
          />
        </button>

        {isOpen && (
          <div className="pbt-timeline-row__expanded">
            {assignedGroups.length === 0 ? (
              <button type="button" className="pbt-add-room-tile pbt-add-room-tile--full" onClick={onBookRoom}>
                <BedDouble size={18} />
                <span>Book a Room</span>
              </button>
            ) : (
              <div className="pbt-room-grid">
                {assignedGroups.map((group, i) => (
                  <RoomSegmentCard
                    key={group.booking_ids[0]}
                    group={group}
                    roomIndex={i}
                    stayInKey={utcToLADateKey(period.check_in_date)}
                    stayOutKey={utcToLADateKey(period.check_out_date)}
                    competitionId={competitionId}
                    participantId={participantId}
                    participantName={participantName}
                    guests={guests}
                    onChanged={onChanged}
                  />
                ))}
                <button type="button" className="pbt-add-room-tile" onClick={onBookRoom}>
                  <Plus size={16} />
                  <span>Add another room</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StayTimelineRow;
